import React from 'react';
import { SvgIconProps, SvgIcon } from '@material-ui/core';

export const AccountOutlinedIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path transform="translate(4 4)" id="a" d="M8 8c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0 7c-2.67 0-8 1.34-8 4v2c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-2c0-2.66-5.33-4-8-4zm6 5H2v-.99C2.2 12.29 5.3 11 8 11s5.8 1.29 6 2v1z" />
  </SvgIcon>
);
